import Modal from 'react-bootstrap/Modal';
import React from 'react';
import './modal.scss'
import { IconModalClose } from '../library/icons';
import classnames from 'classnames';

const CustomModal = (props) => {
  const {
    center = true,
    modalOptions = {},
  } = props;

  const classNames = classnames(props.customClass);
  return (
    <Modal
      centered={center}
      dialogClassName={classNames}
      show={props.show}
      onHide={props.handleClose || (() => {
      })}
      {...modalOptions}
    >
      <div className={`modal-custom-container ${props.customContainerClass}`}>
        <Modal.Header>
          {
            props.handleClose ? (
              <span className="modal-icon-close" onClick={props.handleClose}>
                <IconModalClose width={36} height={36} color={props.colorCloseIcon} />
              </span>
            ) : <></>
          }
        </Modal.Header>
        {props.content || props.children}
      </div>
    </Modal>
  );
};

export default CustomModal;
